import React from "react";
import SkeletonCard from "./SkeletonCard";
import SkeletonPageHeader from "./SkeletonPageHeader";
import SkeletonTable from "./SkeletonTable";

const SkeletonPage = () => {
  return (
    <div style={{ height: "100vh" }}>
      <SkeletonPageHeader />
      <SkeletonCard />
      <SkeletonTable />
    </div>
  );
};

export default SkeletonPage;
